import React from "react"
import Dialog from "../index"
import Text from "../../../../../../_components/Text"

export default props => {
    return <Dialog title="Rejeição" type="warning" show={props.show}>
        <Text color="primary" className="text-center">
            {
                props.message
            }
        </Text>
    </Dialog>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Dialog/NFeRejeited/index.jsx